<app-universal-modal-template
  [state]="state()"
  [groups]="processedGroups()"
  [error]="error()"
  [showCloseButton]="true"
  [isSubmitting]="isSubmitting()"
  [isSubmitted]="isSubmitted()"
  [submittingText]="submittingText()"
  [submittedText]="submittedText()"
  (closeEvent)="onClose()"
  (retryEvent)="onRetry()"
  (componentAction)="onAction($event)"
/>
